/**
 * @desc 分页
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(params: API.bus.requestRecordLog.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/requestRecordLog/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
